/** @format */

import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { FacetVOValue } from '@plp/data-access/interfaces';
import { FilterOptionComponent } from '../filter-option/filter-option.component';
import { HmfActionTextComponent } from '@dsg-tech/homefield-angular';
import { ProductListUIService } from '@plp/data-access/services';
import { StandardFilterComponent } from '../standard-filter/standard-filter.component';

@Component({
  selector: 'plp-components-price-filter',
  imports: [FilterOptionComponent, HmfActionTextComponent],
  templateUrl: './price-filter.component.html',
  styleUrl: './price-filter.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PriceFilterComponent extends StandardFilterComponent {
  private readonly productListUIService = inject(ProductListUIService);

  displayText = computed<{ [key: string]: string }>(() => {
    // For the price filter, map the raw data (ex. *-25) to the formatted text to display (ex. under $25)
    const displayTextObject: { [key: string]: string } = {};
    this.filterOptions().forEach((filterOption: FacetVOValue) => {
      displayTextObject[filterOption.value] = this.productListUIService.addSymbolForPriceDisplay(
        filterOption.value,
      );
    });
    return displayTextObject;
  });

  ariaLabels = computed<string[]>(() => {
    return this.filterOptions().map((filterOption) => {
      return this.displayText()?.[filterOption.value];
    });
  });

  displayValues = computed<string[]>(() => {
    return this.filterOptions().map((filterOption) => {
      return this.displayText()?.[filterOption.value];
    });
  });
}
